<lib-dialog
  [title]="'update-password-pin-dialog.text.update-password' | translate"
  [isLoading]="isLoading"
  [displayActionContainerAsColumnOnMobile]="true"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    {{ 'update-password-pin-dialog.text.enter-pin' | translate }}

    <lib-spacer></lib-spacer>

    <lib-pin-code-input [formControl]="controlPin"></lib-pin-code-input>

    <lib-spacer></lib-spacer>

    <lib-info-box>
      <span
        >{{
          (isUsernameEmail
            ? 'update-password-pin-dialog.text.pin-via-email'
            : 'update-password-pin-dialog.text.pin-via-sms'
          ) | translate
        }}
        {{ username }}</span
      >
    </lib-info-box>
  </div>

  <ng-container action>
    <button
      mat-stroked-button
      color="primary"
      [disabled]="!isAbleToResendPin()"
      (click)="resendPin()"
    >
      {{ 'update-password-pin-dialog.buttons.resend' | translate }}
      <ng-container *ngIf="resendPinCountdownInSecond > 0"
        >({{
          'update-password-pin-dialog.text.in-second'
            | translate : { seconds: resendPinCountdownInSecond }
        }})</ng-container
      >
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToSubmit()"
      (click)="submit()"
    >
      {{ 'update-password-pin-dialog.buttons.submit' | translate }}
    </button>
  </ng-container>
</lib-dialog>
